import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b8a1f17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-max-w-[900px] tw-mx-auto" }
const _hoisted_2 = { class: "tw-flex tw-mb-10" }
const _hoisted_3 = { class: "tw-grow tw-text-center tw-text-5xl tw-font-bold tw-mr-4 rule-title" }
const _hoisted_4 = { class: "tw-self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SfRouterLink = _resolveComponent("SfRouterLink")!
  const _component_HomeSpellingRule = _resolveComponent("HomeSpellingRule")!
  const _component_WordList = _resolveComponent("WordList")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_SpellingPrintablesModal = _resolveComponent("SpellingPrintablesModal")!
  const _component_LockedUserModal = _resolveComponent("LockedUserModal")!
  const _component_TestResultModal = _resolveComponent("TestResultModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-pt-20", _ctx.parentGroup])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.category.spellingRuleName), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SfRouterLink, {
            to: '/',
            class: "sf-btn-primary tw-text-nowrap"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Choose another category ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (r) => {
          return (_openBlock(), _createBlock(_component_HomeSpellingRule, {
            key: r.id,
            rule: r,
            "parent-group": _ctx.parentGroup,
            onShowWordList: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wordListRule = $event)),
            onShowPrintables: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printablesRule = $event)),
            onShowLocked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.lockedVisible = true)),
            onShowResults: _ctx.showTestResults
          }, null, 8, ["rule", "parent-group", "onShowResults"]))
        }), 128))
      ]),
      _createVNode(_component_ModalDialog, {
        show: _ctx.wordListRule != null,
        "is-simple": true,
        "simple-ok-label": "Close",
        onClosed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.wordListRule = null)),
        onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.wordListRule = null))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.printablesRule?.spellingRuleName), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_WordList, {
            "spelling-rule": _ctx.wordListRule,
            class: "sf-modal-body"
          }, null, 8, ["spelling-rule"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_SpellingPrintablesModal, {
        show: _ctx.printablesRule != null,
        "category-id": _ctx.printablesRule?.id,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printablesRule = null)),
        onClosed: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printablesRule = null))
      }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.printablesRule?.spellingRuleName), 1)
        ]),
        _: 1
      }, 8, ["show", "category-id"]),
      _createVNode(_component_LockedUserModal, {
        show: _ctx.lockedVisible,
        onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.lockedVisible = false))
      }, null, 8, ["show"]),
      _createVNode(_component_TestResultModal, {
        "test-result-info": _ctx.detailsResultInfo,
        subject: "spelling",
        student: _ctx.$currentUser.value,
        onClosed: _cache[8] || (_cache[8] = ($event: any) => (_ctx.detailsResultInfo = null))
      }, null, 8, ["test-result-info", "student"])
    ])
  ], 2))
}